// src/hooks/useToast.js
import { useCallback, useMemo } from "react";
import { toast } from "react-toastify";

export function useToast() {
  const toastSuccess = useCallback((message = "Operation successful") =>
    toast.success(message, {
      position: "top-center",
      autoClose: 3000,
    }), []);

  const toastError = useCallback((message = "An error occurred") =>
    toast.error(message, {
      position: "top-center",
      autoClose: 5000,
    }), []);

  const toastInfo = useCallback((message = "Information") =>
    toast.info(message, {
      position: "top-center",
      autoClose: 4000,
    }), []);

  const toastWarning = useCallback((message = "Warning") =>
    toast.warning(message, {
      position: "top-center",
      autoClose: 4000,
    }), []);

  return useMemo(
    () => ({
      toastSuccess,
      toastError,
      toastInfo,
      toastWarning,
    }),
    [toastSuccess, toastError, toastInfo, toastWarning]
  );
}
